import React, { useEffect, useRef } from "react";
import classes from "./GlobalStats.module.css";
import Container from "../../UI/Container/Container";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const GlobalStats = (props) => {
  const headingRef = useRef(0);
  const paraRef = useRef(0);
  const sectionRef = useRef(0);

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: sectionRef.current,
        start: "top 50%",
      },
    });

    timeline.to(headingRef.current, {
      opacity: 1,
      duration: 1,
      ease: "sine.out",
    });
    timeline.to(paraRef.current, {
      opacity: 1,
      duration: 1,
      ease: "sine.out",
    });
  });

  return (
    <div ref={sectionRef} className={classes.GlobalStats}>
      <Container>
        <div className={classes.Content}>
          <div className={classes.Column}>
            <h2 ref={headingRef}>
              <span>18</span> global programs, established and entirely
              maintained by Dickinson.
            </h2>
          </div>
          <div className={classes.Column}>
            <p ref={paraRef}>
              Dickinson also partners with 30+{" "}
              <span>other study-abroad programs in 24 countries</span> on every
              inhabited continent on Earth.
            </p>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default GlobalStats;
